import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import uniqueId from 'lodash/uniqueId';
import ResaleTicketsButton from './ResaleTicketsButton';
import ResaleTicketsFAQ from './ResaleTicketsFAQ';
import * as userAccountActions from '../../../store/actions/user-account-actions';
import './resale-tickets.scss';
import {
    shouldDisplayResaleButton,
} from './resale-tickets-helpers';
import { addQueryParam, getMultilineText, getOauthReturnUrl } from '../../../../../general/js/utils';

class ResaleTickets extends Component {
    constructor(props) {
        super(props);
        this.handleTicketsResaleBuy = this.handleTicketsResaleBuy.bind(this);
        this.handleTicketsResaleSell = this.handleTicketsResaleSell.bind(this);
        this.getOauthResaleRedirectUri = this.getOauthResaleRedirectUri.bind(this);
    }

    handleTicketsResaleBuy(event) {
        event.preventDefault();
        const { actions, formData } = this.props;

        actions.handleRedirectToResaleTickets({
            resaleTicketsUrl: formData.buyLink,
            secutixResaleUrl: formData.secutixResaleUrl,
            secutixPointOfSaleId: formData.secutixPointOfSaleId,
            secutixVirtualOperator: formData.secutixVirtualOperator,
            redirectUri: this.getOauthResaleRedirectUri()
        });
    }

    getOauthResaleRedirectUri() {
        const { renderedComponent } = this.props;

        const returnUri = getOauthReturnUrl({
            useEncode: false
        });

        if (returnUri.includes('account/profile')) {
            return encodeURIComponent(addQueryParam(returnUri, 'componentToRender', renderedComponent));
        }

        return encodeURIComponent(returnUri);
    }

    handleTicketsResaleSell(event) {
        event.preventDefault();
        const { actions, formData } = this.props;
        actions.handleRedirectToResaleTickets({
            resaleTicketsUrl: formData.sellLink,
            secutixResaleUrl: formData.secutixResaleUrl,
            secutixPointOfSaleId: formData.secutixPointOfSaleId,
            secutixVirtualOperator: formData.secutixVirtualOperator,
            redirectUri: this.getOauthResaleRedirectUri()
        });
    }

    render() {
        const {
            formData,
            accountData,
        } = this.props;
        const {
            resaleTicketsTitle,
            resaleTicketsInformation,
            sellButtonCriteria,
            buyButtonCriteria,
            resaleTicketsImageSource,
            resaleTicketsImageText,
            resaleTicketsFAQTitle,
            resaleTicketsFAQs,
            resaleTicketsIntro
        } = formData;

        const { ballotCriteria } = accountData;
        const { membership } = accountData;

        const showBuyLink = shouldDisplayResaleButton(buyButtonCriteria, ballotCriteria, membership);
        const showSellLink = shouldDisplayResaleButton(sellButtonCriteria, ballotCriteria, membership);

        const texts = getMultilineText(resaleTicketsInformation);

        return (
            <Fragment>
                <h1>{resaleTicketsTitle}</h1>
                <div className="resale-tickets">
                    <p className='dashboard-info'>{resaleTicketsIntro}</p>
                    <div className='intro'>
                        <div className='text-image-button'>
                            <div className='text'>
                                {texts.map((introText) => {
                                    return <p key={uniqueId()}>{introText}</p>;
                                })}
                            </div>
                            <div className='tickets-resale-buttons'>
                                {showBuyLink &&
                        <ResaleTicketsButton onResaleClick = {this.handleTicketsResaleBuy} buttonText="Buy tickets" buttonColor="blue"></ResaleTicketsButton>}
                                {showSellLink &&
                        <ResaleTicketsButton onResaleClick = {this.handleTicketsResaleSell} buttonText="Sell tickets" buttonColor="yellow"></ResaleTicketsButton>}
                            </div>
                        </div>
                        <div className='form'>
                            <div className='text'>
                                {texts.map((introText) => {
                                    return <p key={uniqueId()}>{introText}</p>;
                                })}
                            </div>
                            <div className='image image--titled'>
                                <img className='lazyautosizes lazyloaded'
                                    data-sizes='auto'
                                    alt=''
                                    sizes='499px'
                                    srcSet={resaleTicketsImageSource}>
                                </img>
                            </div>
                            {!isEmpty(resaleTicketsImageText) &&
                            <p>{resaleTicketsImageText}</p>}
                        </div>

                    </div>
                    <ResaleTicketsFAQ title={resaleTicketsFAQTitle} questions={resaleTicketsFAQs} ></ResaleTicketsFAQ>
                </div>
            </Fragment >
        );
    }
}

ResaleTickets.propTypes = {
    formData: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    return {
        loading: state.apiStatus.apiCallsInProgress > 0,
        homePageTicketsData: state.userAccount.homePageTicketsData,
        loadHomePageTicketsDataErrorMessages: state.userAccount.loadHomePageTicketsDataErrorMessages,
        isTicketsDataLoadedSuccessful: state.userAccount.isTicketsDataLoadedSuccessful,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            handleRedirectToResaleTickets: bindActionCreators(userAccountActions.handleRedirectToResaleTickets, dispatch),
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ResaleTickets);
